/* eslint-disable react/no-array-index-key */
import React, { Fragment, useEffect } from 'react';
import { HeadingText, Tile, BodyText, Row, Container, Link } from '@paypalcorp/pp-react';
import AUComplaintData from './auCompliantsData.json';
import { trackLink, trackPage } from '../../../lib/analytics-helper';

const AustraliaComponent = function () {
  useEffect(() => {
    trackPage({ id: 'complaintsPageLoad', link: 'smarthelp-complaints-page' });
  }, []);

  const complaintsLinkClick = (urlClicked) => {
    trackLink({ id: 'complaintsPage', link: `smarthelp-complaints-page-complaints-link-clicked|${urlClicked}` });
  };

  const introHeader = () => (
    <div>
      <div className="brexit-complaints-page__intro-icon" />
      <div className="brexit-complaints-page__icon_text">
        <div className="brexit-complaints-page__icon_text__complaints-header">
          <h3 className="brexit-complaints-page__icon_text__complaints-header__intro-topic">
            {AUComplaintData.Header.HeaderIntro}
          </h3>
          <h5 className="brexit-complaints-page__icon_text__complaints-header__country">
            {AUComplaintData.Header.HeaderCountry}
          </h5>
        </div>
      </div>
    </div>
  );
  const mainBody = () => (
    <Container className="AuContainer">
      <Row>
        <HeadingText className="HeadingText" size="lg">
          {AUComplaintData.Body.SubSection1.Header}
        </HeadingText>
      </Row>

      <Row>
        <BodyText>{AUComplaintData.Body.SubSection1.Content.p1}</BodyText>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection1.Content.p2}</BodyText>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection1.Content.p3}</BodyText>
      </Row>

      <Row>
        <Tile card className="HighlightedArea">
          <Tile.Content>
            {AUComplaintData.Body.SubSection1.HiglightedContent}
            <a
              href="https://www.paypal.com/au/webapps/mpp/ua/privacy-full?locale.x=en_AU"
              target="_self"
              onClick={() =>
                complaintsLinkClick('https://www.paypal.com/au/webapps/mpp/ua/privacy-full?locale.x=en_AU')
              }
            >
              <span className="linkContent">{AUComplaintData.Body.SubSection1.linkedContent}</span>
            </a>
          </Tile.Content>
        </Tile>
      </Row>

      <Row>
        <HeadingText className="HeadingText" size="lg">
          {AUComplaintData.Body.SubSection2.Header}
        </HeadingText>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection2.TableHeader}</BodyText>
      </Row>
      <Row className="hsScroll">
        <table>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection2.Table.RowOne.ColumnOne}</th>
            <th className="tableCellsTwo">
              <a
                className="linkContentTable"
                href={`mailto:${AUComplaintData.Body.SubSection2.Table.RowOne.ColumnTwo}`}
                onClick={() => complaintsLinkClick('auexecutiveescalations@paypal.com')}
              >
                {AUComplaintData.Body.SubSection2.Table.RowOne.ColumnTwo}
              </a>
            </th>
          </tr>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection2.Table.RowTwo.ColumnOne}</th>
            <th className="tableCellsTwo">
              {AUComplaintData.Body.SubSection2.Table.RowTwo.ColumnTwo.split('\n').map((item, key) => (
                <span key={key}>
                  {item}
                  <br />
                </span>
              ))}
              <span className="linkContentTable">
                <a
                  href="/smarthelp/contact-us"
                  target="_self"
                  onClick={() => complaintsLinkClick('smarthelp/contact-us')}
                >
                  {AUComplaintData.Body.SubSection2.Table.RowTwo.linkedContent}
                </a>
              </span>
            </th>
          </tr>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection2.Table.RowThree.ColumnOne}</th>
            <th className="tableCellsTwo">
              {AUComplaintData.Body.SubSection2.Table.RowThree.ColumnTwo.split('\n').map((item, key) => (
                <span key={key}>
                  {item}
                  <br />
                </span>
              ))}
            </th>
          </tr>
        </table>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection2.Content.p1}</BodyText>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection2.Content.p2}</BodyText>
      </Row>
      <Row>
        <HeadingText className="HeadingText" size="lg">
          {AUComplaintData.Body.SubSection3.Header}
        </HeadingText>
      </Row>
      <Fragment>
        <Row>
          <BodyText>{AUComplaintData.Body.SubSection3.Content.p1}</BodyText>
        </Row>
        <Row>
          <BodyText>{AUComplaintData.Body.SubSection3.Content.p2}</BodyText>
        </Row>
        <Row>
          <BodyText>{AUComplaintData.Body.SubSection3.Content.p3}</BodyText>
        </Row>
      </Fragment>
      <Row>
        <HeadingText className="HeadingText" size="lg">
          {AUComplaintData.Body.SubSection4.Header}
        </HeadingText>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection4.Content.p1}</BodyText>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection4.TableHeaderOne}</BodyText>
      </Row>
      <Row className="hsScroll">
        <table>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection4.TableOne.RowOne.ColumnOne}</th>
            <th className="tableCellsTwo">{AUComplaintData.Body.SubSection4.TableOne.RowOne.ColumnTwo}</th>
          </tr>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection4.TableOne.RowTwo.ColumnOne}</th>
            <th className="tableCellsTwo">
              {AUComplaintData.Body.SubSection4.TableOne.RowTwo.ColumnTwo.split('\n').map((item, key) => (
                <span key={key}>
                  {item}
                  <br />
                </span>
              ))}
            </th>
          </tr>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection4.TableOne.RowThree.ColumnOne}</th>
            <th className="tableCellsTwo">
              <a
                className="linkContentTable"
                href={`mailto:${AUComplaintData.Body.SubSection4.TableOne.RowThree.ColumnTwo}`}
                onClick={() => complaintsLinkClick('info@afca.org.au')}
              >
                {AUComplaintData.Body.SubSection4.TableOne.RowThree.ColumnTwo}
              </a>
            </th>
          </tr>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection4.TableOne.RowFour.ColumnOne}</th>
            <th className="tableCellsTwo">
              {AUComplaintData.Body.SubSection4.TableOne.RowFour.ColumnTwo}
              <span className="linkContentTable">
                <a
                  href="https://www.afca.org.au/"
                  target="_self"
                  onClick={() => complaintsLinkClick('https://www.afca.org.au/')}
                >
                  {AUComplaintData.Body.SubSection4.TableOne.RowFour.linkedContent}
                </a>
              </span>
            </th>
          </tr>
        </table>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection4.TableHeaderTwo}</BodyText>
      </Row>
      <Row className="hsScroll">
        <table>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection4.TableTwo.RowOne.ColumnOne}</th>
            <th className="tableCellsTwo">{AUComplaintData.Body.SubSection4.TableTwo.RowOne.ColumnTwo}</th>
          </tr>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection4.TableTwo.RowTwo.ColumnOne}</th>
            <th className="tableCellsTwo">
              {AUComplaintData.Body.SubSection4.TableTwo.RowTwo.ColumnTwo.split('\n').map((item, key) => (
                <span key={key}>
                  {item}
                  <br />
                </span>
              ))}
            </th>
          </tr>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection4.TableTwo.RowThree.ColumnOne}</th>
            <th className="tableCellsTwo">
              {AUComplaintData.Body.SubSection4.TableTwo.RowThree.ColumnTwo}
              <span className="linkContentTable">
                <a
                  href="https://www.oaic.gov.au/about-us/contact-us/"
                  target="_self"
                  onClick={() => complaintsLinkClick('https://www.oaic.gov.au/about-us/contact-us/ ')}
                >
                  {AUComplaintData.Body.SubSection4.TableTwo.RowThree.linkedContent}
                </a>
              </span>
            </th>
          </tr>
          <tr>
            <th className="tableCellsOne">{AUComplaintData.Body.SubSection4.TableTwo.RowFour.ColumnOne}</th>
            <th className="tableCellsTwo">
              {AUComplaintData.Body.SubSection4.TableTwo.RowFour.ColumnTwo}
              <span className="linkContentTable">
                <a
                  href="https://www.oaic.gov.au/"
                  target="_self"
                  onClick={() => complaintsLinkClick('https://www.oaic.gov.au/')}
                >
                  {AUComplaintData.Body.SubSection4.TableTwo.RowFour.linkedContent}
                </a>
              </span>
            </th>
          </tr>
        </table>
      </Row>
      <Row>
        <HeadingText className="HeadingText" size="lg">
          {AUComplaintData.Body.SubSection5.Header}
        </HeadingText>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection5.Content}</BodyText>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection5.TableHeader}</BodyText>
      </Row>
      <Row>
        <table>
          <tr>
            <th className="tableCellsOne disablityContent">
              {AUComplaintData.Body.SubSection5.Table.RowOne.ColumnOne.split('\n').map((item, key) => (
                <span key={key} className={key === 0 ? 'disablityContentColor' : null}>
                  {item}
                  <br />
                </span>
              ))}
            </th>
            <th className="tableCellsOne disablityContent ">
              {AUComplaintData.Body.SubSection5.Table.RowOne.ColumnTwo.split('\n').map((item, key) => (
                <span key={key} className={key === 0 ? 'disablityContentColor' : null}>
                  {item}
                  <br />
                </span>
              ))}
            </th>
            <th className="tableCellsOne disablityContent ">
              {AUComplaintData.Body.SubSection5.Table.RowOne.ColumnThree.split('\n').map((item, key) => (
                <span key={key} className={key === 0 ? 'disablityContentColor' : null}>
                  {item}
                  <br />
                </span>
              ))}
            </th>
          </tr>
        </table>
      </Row>
      <Row>
        <Tile card className="HighlightedArea">
          <Tile.Content>
            {AUComplaintData.Body.SubSection5.HiglightedContent}
            <a
              href={AUComplaintData.Body.SubSection5.link}
              target="_self"
              onClick={() =>
                complaintsLinkClick(
                  'https://www.infrastructure.gov.au/media-technology-communications/phone/services-people-with-disability/accesshub',
                )
              }
            >
              <span className="linkContent">{AUComplaintData.Body.SubSection5.linkedContent}</span>
            </a>
          </Tile.Content>
        </Tile>
      </Row>
      <Row>
        <HeadingText className="HeadingText" size="lg">
          {AUComplaintData.Body.SubSection6.Header}
        </HeadingText>
      </Row>
      <Row>
        <BodyText>{AUComplaintData.Body.SubSection6.Content}</BodyText>
      </Row>
      {AUComplaintData.Body.SubSection6.pdfContent.map((pdfContent) => (
        <Row>
          <Link theme="v2" href={pdfContent.LinkedContent}>
            {pdfContent.Heading}
          </Link>
        </Row>
      ))}
    </Container>
  );

  return (
    <Fragment>
      {introHeader()}
      {mainBody()}
    </Fragment>
  );
};

export default AustraliaComponent;
